<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>

    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <p class="p-login">{{ $t('nueva_contrasena') }}</p>
                  <b-form-input
                    alternative
                    class="mb-3"
                    :name="$t('nueva_contrasena')"
                    :rules="{ required: true, min: 5 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    v-model="form.password"
                    :state="fieldState('password')"
                    :placeholder="$t('ingrese_nueva_contrasena')"
                    @input="clearError"
                  ></b-form-input>

                  <p class="p-login">{{ $t('confirmar_nueva_contrasena') }}</p>
                  <b-form-input
                    alternative
                    class="mb-3"
                    :name="$t('confirmar_nueva_contrasena')"
                    :rules="{ required: true, min: 5 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    v-model="form.confirmPassword"
                    :state="fieldState('confirmPassword')"
                    :placeholder="$t('confirme_nueva_contrasena')"
                    @input="clearError"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="showError">
                    <h3 class="text-center mb-2">
                      <b-badge variant="danger">
                        {{ errorMessage }}
                      </b-badge>
                    </h3>
                  </b-form-invalid-feedback>

                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">{{ $t('restablecer_contrasena') }}</base-button>
                  </div>

                  <div class="text-center mt-2">
                    <a :href="ecommerceUrl" class="text-black d-block">
                      <small>{{ $t('volver_login') }}</small>
                    </a>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
  
</template>

<script>
import authService from '@/api/authService';

export default {
  data() {
    return {
      form: {
        password: '',
        confirmPassword: ''
      },
      showError: false,
      errorMessage: '',
      fieldErrors: {
        password: null,
        confirmPassword: null
      }
    };
  },
  created() {
    // El translator no es reactivo: forzamos el idioma desde ?lang antes de renderizar.
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    if (urlLang && ['es', 'en'].includes(urlLang)) {
      this.$setLanguage(urlLang);
      this.$forceUpdate();
    }
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
    ecommerceUrl() {
      return process.env.VUE_APP_ECOMMERCE_URL || 'https://ecommerce.inexlink.com';
    }
  },
  methods: {
    fieldState(field) {
      return this.fieldErrors[field];
    },
    clearError() {
      this.showError = false;
      this.errorMessage = '';
      this.fieldErrors.password = null;
      this.fieldErrors.confirmPassword = null;
    },
    async onSubmit() {
      try {
        if (!this.token) {
          this.showError = true;
          this.errorMessage = this.$t('token_invalido');
          return;
        }

        if (this.form.password !== this.form.confirmPassword) {
          this.showError = true;
          this.errorMessage = this.$t('contrasenas_no_iguales');
          this.fieldErrors.password = false;
          this.fieldErrors.confirmPassword = false;
          return;
        }

        Swal.fire({
          html: `<div style="display: flex; align-items: center; justify-content: center;">
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('actualizando_contrasena')}</h3>
                        </div>
                    </div>`,
          showConfirmButton: false,
          allowOutsideClick: false
        });

        await authService.resetPassword({
          token: this.token,
          password: this.form.password
        });

        Swal.fire({
          icon: 'success',
          title: this.$t('contrasena_actualizada'),
          text: this.$t('contrasena_actualizada_desc'),
          confirmButtonText: this.$t('ir_al_login')
        }).then(() => {
          window.location.href = this.ecommerceUrl;
        });
      } catch (error) {
        Swal.close();
        this.showError = true;
        this.errorMessage = error.message || this.$t('error_restablecer');
      }
    }
  }
};
</script>

<style scoped>
.p-login {
  margin-bottom: 0;
}
</style>
